'use client'
import PageDesignWrapper from '@/components/page-design-wrapper/page-design-wrapper'
import { usePathname } from 'next/navigation'
import { CanadaData, MedicalData } from './special-layout-objects'

const LayoutTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const router = usePathname()
  const data = router === '/Canada' ? CanadaData : MedicalData
  return (
    <>
      <div
        className={`flex items-center justify-center
          ${
            router === '/Canada'
              ? 'bg-canada-gradient'
              : `bg-medical-gradient
              bg-[left_-23px] sm:bg-[url('/images/favicons/medicalLayout.svg')] md:bg-cover`
          }`}
      >
        <PageDesignWrapper data={data} />
      </div>

      {children}
    </>
  )
}

export default LayoutTheme
